import type { ReactNode } from 'react'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { theme } from '@/theme'
import { ToastProvider } from '@/shared/toast/ToastProvider'
import { QueryProvider } from './QueryProvider'

export function AppProviders({
  children,
}: {
  readonly children: ReactNode
}) {
  return (
    <QueryProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToastProvider>{children}</ToastProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </QueryProvider>
  )
}
